import axios from 'axios'

const url = process.env.REACT_APP_API_URL_SIGNATURE

const authConfig = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
})

class SignatureService {
    getStatus(documentId) {
        return axios.get(`${url}/api/documents/${documentId}/signature-status`, authConfig())
    }

    sign(documentId, payload) {
        const config = authConfig()
        config.headers['Content-Type'] = 'application/json'
        return axios.post(`${url}/api/documents/${documentId}/sign`, payload, config)
    }

    downloadSigned(documentId) {
        return axios.get(`${url}/api/documents/${documentId}/download-signed`, {
            ...authConfig(), responseType: 'blob'
        })
    }
}

export default new SignatureService()
